export default __webpack_public_path__ + "static/media/vire16.51840440.jpg";